<div class="auth-shell">
  @if (screenType === 'MONITOR') {
    <div class="auth-brand-panel">
      <div class="auth-brand-content">
        <img src="/assets/logo.png" alt="Hospo Fresh" class="auth-brand-logo" />
        <p class="auth-brand-tagline">Hospitality is our thing!</p>
      </div>
      <div class="auth-brand-footer">
        Copyright &copy; {{ currentYear }} DSS Australia Pty Ltd. All Rights Reserved.
      </div>
    </div>
  }

  <div class="auth-form-panel">
    <router-outlet></router-outlet>
    <div class="auth-form-footer">
      Copyright &copy; {{ currentYear }} DSS Australia Pty Ltd. All Rights Reserved.
    </div>
  </div>
</div>
